import { CsvButton } from '@components/Buttons/CsvButton';
import { Pagination } from '@components/Table/Pagination';
import { TableLinearLoading } from '@components/Table/TableLinearLoading';
import { TableNoResult } from '@components/Table/TableNoResult';
import { TableSortCell } from '@components/Table/TableSortCell';
import { TableSortRow } from '@components/Table/TableSortRow';
import { TableWrapper } from '@components/Table/TableWrapper';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { useContratoClienteStatusColor } from '@model/ContratoClienteStatus';
import { IRelatorioValorFranquiaPlanosFilter, IRelatorioValorFranquiaPlanosRecord } from '@services/Relatorios/ValorFranquiaPlanos';
import React from 'react';

export type RelatorioValorFranquiaPlanosTableProps = {
    data: IData<IRelatorioValorFranquiaPlanosRecord, IRelatorioValorFranquiaPlanosFilter>
    isLoading: boolean
    onCsvButtonClick: VoidFunction
}

export function RelatorioValorFranquiaPlanosTable ({ data, isLoading, onCsvButtonClick }: RelatorioValorFranquiaPlanosTableProps) {
    const formatter = useFormatter();
    const contratoClienteStatusColor = useContratoClienteStatusColor();

    return (
        <React.Fragment>
            <TableWrapper>
                <TableLinearLoading isLoading={isLoading} />
                <TableNoResult itemCount={data.itemsCount}>
                    <TableHead>
                        <Pagination pagination={data.pagination}>
                            <CsvButton onClick={onCsvButtonClick} disabled={isLoading} />
                        </Pagination>

                        <TableSortRow sort={data.sort}>
                            <TableSortCell fieldName="linhaContratoOperadoraEmpresaNome">Empresa</TableSortCell>
                            <TableSortCell fieldName="linhaContratoOperadoraOperadoraNome">Operadora</TableSortCell>
                            <TableSortCell fieldName="valorPlano">Vlr. Plano</TableSortCell>
                            <TableSortCell fieldName="franquiaGb">Franquia GB</TableSortCell>
                            <TableSortCell fieldName="contratoClienteStatusNome">Status</TableSortCell>
                            <TableSortCell fieldName="quantidade">Quantidade</TableSortCell>
                        </TableSortRow>
                    </TableHead>
                    
                    <TableBody>
                        {
                            data.items.map((valorFranquiaPlanos, index) => {
                                return (
                                    <TableRow key={index}>
                                        <TableCell>{valorFranquiaPlanos.linhaContratoOperadoraEmpresaNome}</TableCell>
                                        <TableCell>{valorFranquiaPlanos.linhaContratoOperadoraOperadoraNome}</TableCell>
                                        <TableCell>{formatter.toFloat(valorFranquiaPlanos.valorPlano)}</TableCell>
                                        <TableCell>{formatter.toFloat(valorFranquiaPlanos.franquiaGb)}</TableCell>

                                        <TableCell 
                                            className={contratoClienteStatusColor[valorFranquiaPlanos.contratoClienteStatusId]}
                                        >
                                            { valorFranquiaPlanos.contratoClienteStatusNome }
                                        </TableCell>

                                        <TableCell>{valorFranquiaPlanos.quantidade}</TableCell>
                                    </TableRow>
                                )
                            })
                        }

                        <Pagination pagination={data.pagination}>
                            <CsvButton onClick={onCsvButtonClick} disabled={isLoading} />
                        </Pagination>

                    </TableBody>
                </TableNoResult>
            </TableWrapper>
        </React.Fragment>
    )
}